import { render, staticRenderFns } from "./ProductReadyNew.vue?vue&type=template&id=e4b6b770&scoped=true"
import script from "./ProductReadyNew.vue?vue&type=script&lang=js"
export * from "./ProductReadyNew.vue?vue&type=script&lang=js"
import style0 from "./ProductReadyNew.vue?vue&type=style&index=0&id=e4b6b770&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b6b770",
  null
  
)

export default component.exports